/*
 *  -----------------------------------------------------------------------
 *    <copyright file="confirmation-control-dialog.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogContent } from '@mui/material';
import { LovUsageCounts } from '../add-lov.helper';
import { useTranslation } from 'hooks';
import { NamedItemType } from 'types/graphql-global-types';
import Button from 'views/components/core/buttons';

import { CustomDialog, DialogActions, DialogTitle } from 'views/components/core/dialog';

import './confirmation-lov-dialog.scss';

const ConfirmationLovDialog = ({
    open,
    close,
    inactivate,
    observationsCount,
    lovType,
    usageCounts,
    usageCheckFailed,
}: {
    open: boolean;
    close: Function;
    inactivate: Function;
    observationsCount: number;
    lovType?: NamedItemType | null;
    usageCounts?: LovUsageCounts | null;
    usageCheckFailed?: boolean;
}) => {
    const { t } = useTranslation();

    return (
        <CustomDialog onClose={close} fullWidth maxWidth="sm" scroll="paper" open={open}>
            <DialogTitle id="confirmation-lov-dialog-modal-title">
                {t('admin:inactivateLOV')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    onClick={() => {
                        close();
                    }}
                    data-testid="close-dialog"
                />
            </DialogTitle>
            <DialogContent className="confirmation-lov-dialog-content">
                <p className="main-text">
                    {lovType === NamedItemType.REVIEW_LOG_DECISION ||
                    lovType === NamedItemType.CONTROLS_REVIEW_LOG_DECISION ||
                    lovType === NamedItemType.SM_REVIEW_LOG_DECISION ||
                    usageCheckFailed
                        ? t('admin:lovAssociatedToAtLeastOne')
                        : usageCounts
                          ? t('admin:lovAssociatedToOrgAndStudyRecords', {
                                orgLibraryCount: usageCounts.orgLibraryCount,
                                studyRecordCount: usageCounts.studyRecordCount,
                                studyCount: usageCounts.studyCount,
                            })
                          : t('admin:lovAssociatedToRecords', { observationsCount })}
                </p>
                <p className="main-text">{t('admin:confirmInactivateLov')}</p>
                <DialogActions className="confirmation-lov-actions">
                    <Button
                        id="no-confirm-lov-btn"
                        className="confirmation-lov-btn"
                        text="common:no"
                        onClick={() => {
                            inactivate(false);
                        }}
                    />
                    <Button
                        id="confirm-lov-btn"
                        className="confirmation-lov-btn"
                        text="common:yes"
                        onClick={() => {
                            inactivate(true);
                        }}
                    />
                </DialogActions>
            </DialogContent>
        </CustomDialog>
    );
};

export default ConfirmationLovDialog;
